<template>
  <BaseAction>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <SecondaryButton
          :loading="isLoading || isFetchingTalentPools"
          color="primary"
          v-on="on"
        >
          <div class="d-flex">
            <v-icon small>
              mdi-arrow-right
            </v-icon>
            <v-img
              contain
              height="15px"
              src="@/assets/svg/pool_white_icon.svg"
              class="mr-2"
            />
          </div>
          Add to Talent Pool..
        </SecondaryButton>
      </template>
      <v-list>
        <v-list-item-group>
          <v-list-item v-for="talentPool in talentPools" :key="talentPool.id">
            <v-list-item-avatar height="30px">
              <v-img
                contain
                height="15px"
                src="@/assets/svg/pool_primary_icon.svg"
              />
            </v-list-item-avatar>
            <v-list-item-content @click="addToPool(talentPool.id)">
              {{ talentPool.name }}
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { ADD_USERS_TO_TALENT_POOL } from "@/store/modules/talentPools/actions";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers(
  TALENT_POOLS_NAMESPACE
);

export default {
  components: {
    BaseAction,
    SecondaryButton
  },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    selectedCandidates: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      talentPools: state => state.talentPools,
      isFetchingTalentPools: state => state.isFetchingTalentPools
    })
  },
  methods: {
    ...mapActions({
      addUsersToTalentPool: ADD_USERS_TO_TALENT_POOL
    }),
    async addToPool(id) {
      this.isLoading = true;
      await this.addUsersToTalentPool({
        id,
        users: this.selectedCandidates
      });
      this.$emit("success");
      this.isLoading = false;
    }
  }
};
</script>
